<template>
	<div class="columns form-info-panel">
		<div
			:class="['column', fieldsColumn, { 'field-column': !fieldsColumn }]"
		>
			<slot name="fields"></slot>
		</div>
		<div v-if="hasInfoSlot" :class="['column', infoColumn]">
			<div class="sidebar">
				<app-tip-text class="content">
					<slot name="info"></slot>
				</app-tip-text>
			</div>
		</div>
	</div>
</template>

<script>
import AppTipText from "@/components/AppTipText";
export default {
	components: {
		AppTipText
	},
	props: {
		fieldsColumn: {
			type: String,
			default: () => "is-7"
		},
		infoColumn: {
			type: String,
			default: () => "is-4 is-offset-1"
		}
	},
	computed: {
		hasInfoSlot() {
			return !!this.$slots["info"];
		}
	}
};
</script>

<style scoped>
.form-info-panel {
	max-width: 960px;
}
.sidebar {
	position: -webkit-sticky;
	position: sticky;
	top: 5rem;
	/* margin-top: 49px; */
}
</style>
